
const ApplicationsContainerJSX = props => (
    <div>
        {props.children}
    </div>
)

export default ApplicationsContainerJSX